// Sentiment gauge — semicircle meter + bull/bear tallies.
export default function SentimentMeter({ sentiment, size = "md" }) {
  const s = sentiment || { bullish: 0, bearish: 0, neutral: 0, mentions: 0, score: 0, mode: "keyword" };
  const score = s.score || 0; // -100..100
  const pct = (score + 100) / 2; // 0..100
  const angle = -90 + (pct / 100) * 180;
  const label = score > 25 ? "BULLISH" : score < -25 ? "BEARISH" : "NEUTRAL";
  const color = score > 25 ? "hsl(var(--bull))" : score < -25 ? "hsl(var(--bear))" : "hsl(var(--neutral))";
  const R = 52, cx = 60, cy = 60;
  const arc = (from, to) => {
    const p = (a) => [cx + R * Math.cos((a * Math.PI) / 180), cy + R * Math.sin((a * Math.PI) / 180)];
    const [x1, y1] = p(from), [x2, y2] = p(to);
    return `M ${x1} ${y1} A ${R} ${R} 0 0 1 ${x2} ${y2}`;
  };
  const small = size === "sm";

  return (
    <div className="flex items-center gap-4">
      <div className={small ? "w-24" : "w-32"}>
        <svg viewBox="0 0 120 70" className="w-full">
          <path d={arc(180, 360)} fill="none" stroke="hsl(var(--muted))" strokeWidth="10" strokeLinecap="round" />
          <path d={arc(180, 240)} fill="none" stroke="hsl(var(--bear))" strokeWidth="10" strokeLinecap="round" opacity="0.35" />
          <path d={arc(300, 360)} fill="none" stroke="hsl(var(--bull))" strokeWidth="10" strokeLinecap="round" opacity="0.35" />
          <line x1={cx} y1={cy} x2={cx + (R - 8) * Math.cos((angle - 90) * Math.PI / 180 + Math.PI)}
                y2={cy + (R - 8) * Math.sin((angle - 90) * Math.PI / 180 + Math.PI)}
                stroke={color} strokeWidth="3" strokeLinecap="round"
                transform={`rotate(${angle} ${cx} ${cy})`} style={{ transition: "all 0.6s ease" }} />
          <line x1={cx} y1={cy} x2={cx} y2={cy - (R - 8)} stroke={color} strokeWidth="3.5" strokeLinecap="round"
                transform={`rotate(${angle} ${cx} ${cy})`} style={{ transition: "transform 0.6s ease" }} />
          <circle cx={cx} cy={cy} r="5" fill={color} />
        </svg>
      </div>
      <div>
        <div className="font-display font-bold text-lg leading-none" style={{ color }}>{label}</div>
        <div className="text-xs text-muted-foreground mt-1">
          <span className="text-bull font-mono">{s.bullish}▲</span> · <span className="text-bear font-mono">{s.bearish}▼</span> · {s.mentions} mentions
        </div>
        <div className="text-[10px] text-muted-foreground uppercase tracking-wider mt-0.5">{s.mode} · score {score}</div>
      </div>
    </div>
  );
}
